var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weixin-login"},[_c('div',{staticClass:"qrcode-box",attrs:{"id":"weixin-Img"}}),_vm._m(0),_c('p',{staticClass:"weixin-agreement"},[_vm._v(" 扫码即表示同意 "),_c('span',{staticStyle:{"color":"#0059ab","cursor":"pointer"},on:{"click":_vm.openPrivacyPolicy}},[_vm._v("《用户隐私协议》")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"weixin-tip"},[_vm._v("使用微信扫一扫登录"),_c('br')])
}]

export { render, staticRenderFns }